<template>
    <div class="page">
        <div class="more-title">
            <div class="title-txt">
                {{module_name}}
            </div>
        </div>
        <div class="more-content">
            <div class="table-content-More">

                <van-list
                        v-model="loading"
                        :finished="finished"
                        finished-text="没有更多了"
                        @load="bindMoreList"
                        class="live-content"
                        v-if="list.length >0"
                >
                    <div class="content-li" v-for="(item,index) in list" :key="index" @click="bindMusicLog" :data-id="item.course_id" :data-p_id="item.p_course_id" :data-type="item.type">
                        <div class="content-img">
                            <van-image
                                    width="100%"
                                    height="100%"
                                    fit="cover"
                                    :src="item.cover_url"
                                    radius="5"
                            />
                            <div class="content-info-view">
                                <span class="iconfont iconchakan"></span>
                                {{item.view_count}}
                            </div>
                        </div>
                        <div class="content">
                            <div class="content-title">
                                {{item.name}}
                            </div>
                            <div class="content-lecturer">
                                {{item.desc}}
                            </div>
                            <div class="content-info">
                                <div class="content-info-play-time">
                                    {{item.lecturer}}
                                </div>
                                <div class="content-info-play-money">
                                    {{item.money*1==0 ?'免费':'￥'+(item.money*1)}}
                                </div>
                            </div>
                        </div>
                    </div>
                </van-list>
            </div>
        </div>
    </div>
</template>

<script>
    import { List ,Image as VanImage } from 'vant';
    export default {
        name: "index",
        components:{
          [List.name]:List,
          [VanImage.name]:VanImage
        },
        data(){
            return {
                train_layout_id:'',
                index:'',
                total:0,
                page:1,
                pageSize:10,
                list:[],
                module_name:'',
                loading: false,
                finished: false,
            }
        },
        mounted() {
            this.module_name=this.util.getQueryStr('module_name');
            this.train_layout_id = this.util.getQueryStr('train_layout_id');
            this.index = this.util.getQueryStr('index');
            this.$(document).attr('title',this.module_name);

            this.bindMoreList(1);
            this.bindWeiXin();
        },
        methods:{
            bindWeiXin:function(){
                var _self=this;
                this.util.jweixin(function (wx) {
                    var _that=_self;
                    _self.util.wxShare(wx, {
                        title: _that.module_name,
                        desc: _that.module_name,
                        link: location.href,
                        imgUrl: _that.list[0].cover_url
                    });
                });
            },
            bindMusicLog:function(e){
                var id=e.currentTarget.dataset.id;
                var p_id = e.currentTarget.dataset.p_id;
                var type=e.currentTarget.dataset.type;
                this.$router.push(this.util.gotoCurriculumDetailUrl(type,id,p_id));
            },
            bindMoreList:function(page){
                if(!page){
                    var pageNo = this.page;
                    pageNo +=1;

                    this.page=pageNo;

                }else{

                    this.page=page;

                }
                this.util.server.mini_home.list({
                    data: {
                        train_layout_id:this.train_layout_id,
                        index:this.index,
                        page:this.page,
                        pagesize:this.pageSize
                    },
                    callback: (res => {
                        const { code, data, msg } = res;
                        if(code == 1){

                            //赋值总数量
                            if(data.total){
                                this.total=data.total
                            }

                            //1.如果有数据
                            if(data.items && data.items.length>0){
                                if(page == 1){
                                    this.list=data.items;
                                }else{
                                    //如果翻页 则在数组追加数据
                                    this.list = this.list.concat(data.items);
                                }
                                this.loading = false;
                                //判断是否存在下一页
                                if(this.total*1 == this.list.length){
                                    this.finished=true;
                                }
                            }else{

                                //2.无数据
                                //如果当前页为第一页 则设置页面数据为空数组
                                if (page == 1){
                                    this.list=[];
                                    this.finished=true;
                                    this.loading = false;
                                }
                            }
                        }else{

                            this.util.showToast({
                                message: msg
                            });
                        }
                    })
                });
            },
        }
    }
</script>

<style scoped>
    .content-img .content-info-view{
        position: absolute;
        font-size: 10px;
        color: #ffffff;
        top: 0;
        margin: 6px;
        margin-top: 16px;
        padding: 2px 6px;
        background: rgba(0,0,0,0.4);
        border-radius: 8px;
    }
    .content-info-view .iconfont{
        font-size: 10px;
    }
    .live-content{
        width: 100%;
        background-color: #fff;
    }
    div{
        color: #3a3a3a;
    }
    .more-title{
        padding: 10px;
        background-color: #fff;
    }
    .more-title .title-txt,.more-title .title-more{
        display: inline-block;
        vertical-align: middle;
    }
    .more-title .title-txt{
        max-width: 80%;
        font-size: 16px;
        font-weight: bold;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
    .table-content-More{
        height: 100%;
        width: 100%;
    }
    .more-content{
        width: 100%;
        background-color: #fff;
        display: flex;
        flex-wrap: wrap;
    }
    .content-li{
        width: 100%;
        padding: 10px;
        position: relative;
        display: flex;
        box-sizing: border-box;
    }
    .content-li .content-img{
        height: 101px;
        width: 135px;
        display: flex;
        font-size: 0;
    }
    .content{
        padding-left: 8px;
        flex: 1;
    }

    .content-info{
        display: flex;
        line-height: 16px;
    }
    .content-li .content-title{
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
        color: #171717;
        font-weight:500;
        height: 40px;
        line-height: 20px;
    }
    .content-li .content-info-play-time{
        font-size: 12px;
        color: #999999;
        flex: 1;
    }
    .content-info-type{
        position: absolute;
        top: 0;
        right: 0;
        margin: 3px;
        padding: 2px 6px;
        font-size: 10px;
        color: #ffffff;
        background: rgba(0,0,0,0.4);
        border-radius: 5px;
    }
    .content-lecturer{
        overflow: hidden;
        color: #999999;
        margin-top: 8px;
        margin-bottom: 15px;
        font-size: 12px;
        height: 17px;
        width: 100%;
        display: flex;
    }
    .content-info-play-money{
        font-size: 12px;
        color: #FF624F;
    }
</style>
